import { com } from '@eidu/web'
import EntityType = com.eidu.entity.type.EntityType
import Field = com.eidu.entity.field.Field
import FieldId = com.eidu.entity.field.FieldId
import FieldType = com.eidu.entity.field.FieldType

export const fieldsOfEntityType = (entityType: EntityType): readonly Field[] => [
  ...entityType.fields.asJsReadonlyArrayView(),
]

// Fields usable in value-based selectors (FieldValueEquals and friends). ReferenceSet fields are excluded because a
// set value can't be matched by those selectors.
export const valueSelectableFieldsOfEntityType = (entityType: EntityType): readonly Field[] =>
  fieldsOfEntityType(entityType).filter((field) => field.type !== FieldType.ReferenceSet)

export const findValueSelectableFieldByIdOrFirst = (
  entityType: EntityType | undefined,
  fieldId: FieldId | undefined
): Field | undefined => {
  if (!entityType) return undefined
  const fields = valueSelectableFieldsOfEntityType(entityType)
  return (fieldId && fields.find(({ id }) => id.equals(fieldId))) || fields[0]
}

export const findFieldById = (entityType: EntityType, fieldId: FieldId): Field | undefined =>
  fieldsOfEntityType(entityType).find(({ id }) => id.equals(fieldId))

export const findEntityTypeByFieldId = (entityTypes: readonly EntityType[], fieldId: FieldId): EntityType | undefined =>
  entityTypes.find((entityType) => {
    const field = findFieldById(entityType, fieldId)
    return field !== undefined
  })

export const entityTypeIdByFieldIdOrFirst = (entityTypes: readonly EntityType[], fieldId: FieldId | undefined) =>
  fieldId ? findEntityTypeByFieldId(entityTypes, fieldId)?.id : entityTypes[0].id

export const findFieldByIdOrFirst = (
  entityType: EntityType | undefined,
  fieldId: FieldId | undefined
): Field | undefined => {
  if (entityType)
    if (fieldId) return findFieldById(entityType, fieldId)
    else return fieldsOfEntityType(entityType)[0]
  else return undefined
}

export {}
